import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutCarrierUpcomingActivities extends Layout {
    sourceUpcomingActivities: DataSource;
    tableUpcomingActivities: Table;
}
